import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Form, Modal } from "react-bootstrap";
import { useParams, useLocation } from "react-router";
import { FormProvider, useForm } from "react-hook-form";
import { ModalHead } from "../common-styling";
import TextField from "../reusable-form-fields/text-field";
import { ACCESS_CONFIG, DEFAULT_WEB_TEMP } from "../strings";
import { saveCustomerWebTemplate } from "../../services/api-declaration";
import { useCustomerWebsiteTabs } from "../../context/customer-website-tabs-context";
import { useTranslation } from "react-i18next";
import {
  getDefaultWebsiteEditorValues,
  getInitialWebsiteEditorValues
} from "../../services/customer-website-helper";
import { isReservedWebsiteTabRoute } from "../../services/website-legal-pages";

const AddNewNestedTabDialog = ({ show, toggleDialog }) => {
  const { MARKETING_MANAGER_TIER } = ACCESS_CONFIG;
  const { t } = useTranslation();
  const params = useParams();
  const { state } = useLocation();
  const { setWebsiteTabs } = useCustomerWebsiteTabs();
  const isHubspotTabSelected = state?.isHubspotTabSelected;

  const addNestedWebsiteTabSchema = Yup.object().shape({
    tabRoute: Yup.string()
      .required("Required")
      .matches(
        /^\/[a-zA-Z]+(?:-[a-zA-Z]+)*$/,
        "Enter a valid route (example: /about-us)"
        // "Geben Sie eine gültige Route ein (z. B. /about)"
      )
      .test(
        "reserved-tab-route",
        t("customerWebsite.reservedTabRoute"),
        (value) => !isReservedWebsiteTabRoute(value)
      )
  });

  const methods = useForm({
    resolver: yupResolver(addNestedWebsiteTabSchema),
    defaultValues: { tabRoute: "/" }
  });

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = methods;

  const onSubmit = async (formValues) => {
    const { tabRoute } = formValues;
    const templateDataWithDefaults = getDefaultWebsiteEditorValues(
      getInitialWebsiteEditorValues(),
      t
    );

    const template = {
      tabRoute,
      isDynamicWebsiteTab: true,
      templateType: DEFAULT_WEB_TEMP,
      active: true,
      isPublished: false,
      oca: 1,
      data: templateDataWithDefaults,
      isHubspotCustomer: isHubspotTabSelected
    };
    try {
      const response = await saveCustomerWebTemplate(params.id, template);
      toggleDialog();

      const newTab = {
        evKey: response.data.data.tabRoute,
        title: response.data.data.tabRoute,
        access: MARKETING_MANAGER_TIER
      };
      setWebsiteTabs((prev) => [...prev, newTab]);
    } catch (error) {
      console.log("Error in saving: ", error);
    }
  };

  return (
    <Modal show={show} onHide={toggleDialog} backdrop="static" centered>
      <ModalHead className="bg-primary text-white">
        <Modal.Title>{"Add New Website Tab"}</Modal.Title>
      </ModalHead>
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <TextField
              name="tabRoute"
              type="text"
              label={"Route Name:"}
              placeholder={"Enter Tab Route"}
              errors={errors?.tabRoute}
              register={register}
              noSpacing
            />
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex">
              <Button type="submit" variant="outline-success">
                {"Add"}
              </Button>
              <Button
                className="ms-2"
                variant="outline-secondary"
                onClick={() => {
                  toggleDialog();
                }}
              >
                {t("common.cancel")}
              </Button>
            </div>
          </Modal.Footer>
        </Form>
      </FormProvider>
    </Modal>
  );
};

export default AddNewNestedTabDialog;
